/* On-Tec Store — Design-Layer (OTD) · Interaktion
   Tabs, Slider-Pfeile, Spotlight-Hover. Ohne Abhängigkeiten. */
(function(){
  'use strict';
  function activeRail(root){
    var panel = root.querySelector('.otd-panel:not([hidden])') || root;
    return panel.querySelector('[data-otd-rail]');
  }
  function updateNav(root){
    var rail = activeRail(root); if(!rail) return;
    var prev = root.querySelector('[data-otd-prev]'), next = root.querySelector('[data-otd-next]');
    var max = rail.scrollWidth - rail.clientWidth - 2;
    if(prev) prev.disabled = rail.scrollLeft <= 2;
    if(next) next.disabled = rail.scrollLeft >= max;
  }
  function init(scope){
    (scope || document).querySelectorAll('[data-otd-tabs]').forEach(function(root){
      if(root.__otd) return; root.__otd = true;
      var tabs = root.querySelectorAll('[role="tab"]');
      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          tabs.forEach(function(t){
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = document.getElementById(t.getAttribute('aria-controls'));
            if(p) p.hidden = !on;
          });
          updateNav(root);
        });
        tab.addEventListener('keydown', function(e){
          if(e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var list = Array.prototype.slice.call(tabs), i = list.indexOf(tab);
          var n = list[(i + (e.key === 'ArrowRight' ? 1 : -1) + list.length) % list.length];
          n.focus(); n.click();
        });
      });
      root.querySelectorAll('[data-otd-prev],[data-otd-next]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var rail = activeRail(root); if(!rail) return;
          var dir = btn.hasAttribute('data-otd-next') ? 1 : -1;
          rail.scrollBy({left: dir * rail.clientWidth * 0.9, behavior: 'smooth'});
        });
      });
      root.querySelectorAll('[data-otd-rail]').forEach(function(rail){
        rail.addEventListener('scroll', function(){ updateNav(root); }, {passive: true});
      });
      updateNav(root);
    });
    (scope || document).querySelectorAll('[data-otd-spotlight]').forEach(function(grid){
      if(grid.__otd) return; grid.__otd = true;
      grid.addEventListener('pointermove', function(e){
        var tile = e.target.closest('.otd-tile'); if(!tile) return;
        var r = tile.getBoundingClientRect();
        tile.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        tile.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* Zentrale Aktion: Countdown + automatisches Ausblenden nach Ablauf / vor Start */
  function parseLocal(v){ if(!v) return NaN; var m=v.match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/); if(!m) return Date.parse(v); return new Date(+m[1],+m[2]-1,+m[3],+(m[4]||0),+(m[5]||0)).getTime(); }
  function pad(n){ return (n<10?'0':'')+n; }
  function promoTick(){
    var now=Date.now();
    document.querySelectorAll('[data-otd-promo]').forEach(function(el){
      var end=parseLocal(el.getAttribute('data-otd-end')), start=parseLocal(el.getAttribute('data-otd-start'));
      if((!isNaN(end)&&now>=end)||(!isNaN(start)&&now<start)){ el.classList.add('is-expired'); return; }
      if(isNaN(end)) return;
      var diff=Math.max(0,Math.floor((end-now)/1000)), d=Math.floor(diff/86400), h=Math.floor(diff%86400/3600), m=Math.floor(diff%3600/60), s=diff%60;
      el.querySelectorAll('[data-otd-countdown]').forEach(function(cd){
        var t = d>1 ? 'noch '+d+' Tage' : d===1 ? 'noch 1 Tag, '+h+' Std.' : 'noch '+pad(h)+':'+pad(m)+':'+pad(s)+' Std.';
        if(cd.textContent!==t) cd.textContent=t;
      });
    });
  }
  promoTick(); setInterval(promoTick, 1000);

  /* Sticky-Kaufleiste auf Produktseiten (≤1024 px) */
  function initBuybar(){
    var atc=document.querySelector('.product--section .product-form--atc-button, .product--section [data-product-atc]');
    if(!atc||document.querySelector('.otd-buybar')) return;
    var titleEl=document.querySelector('.otc-pt-h, .product-title');
    var bar=document.createElement('div'); bar.className='otd-buybar'; bar.setAttribute('aria-hidden','true');
    bar.innerHTML='<div class="otd-buybar__info"><span class="otd-buybar__title"></span><span class="otd-buybar__price"></span></div><button type="button" class="otd-buybar__btn" tabindex="-1">In den Warenkorb</button>';
    bar.querySelector('.otd-buybar__title').textContent=titleEl?titleEl.textContent.trim():'';
    document.body.appendChild(bar);
    var priceOut=bar.querySelector('.otd-buybar__price');
    function sync(){
      var p=document.querySelector('[data-otc-price]')||document.querySelector('.product--section .price__current .money, .product--section .price__current');
      priceOut.textContent=p?p.textContent.trim():'';
      var dis=atc.disabled||atc.classList.contains('disabled');
      bar.style.display=dis?'none':'';
    }
    bar.querySelector('button').addEventListener('click',function(){ atc.click(); });
    new IntersectionObserver(function(es){ es.forEach(function(e){ var show=!e.isIntersecting && e.boundingClientRect.top<0; sync(); bar.classList.toggle('is-visible',show); bar.setAttribute('aria-hidden',show?'false':'true'); }); },{threshold:0}).observe(atc);
    new MutationObserver(sync).observe(atc,{attributes:true,attributeFilter:['disabled','class']});
    sync();
  }

  /* Inhaltsverzeichnis für lange Textseiten und Rechtstexte */
  function initToc(){
    var src=document.querySelector('[data-otd-toc-source]')||document.querySelector('.shopify-policy__body .rte, .shopify-policy__body');
    if(!src) return;
    var heads=[].slice.call(src.querySelectorAll('h2, h3')).filter(function(h){return h.textContent.trim().length>1;});
    if(heads.length<4) return;
    var toc=document.querySelector('[data-otd-toc]');
    if(!toc){
      var pc=document.querySelector('.shopify-policy__container'); if(!pc) return;
      pc.classList.add('otd-pol');
      toc=document.createElement('aside'); toc.className='otd-pg__toc'; toc.setAttribute('data-otd-toc','');
      toc.innerHTML='<p class="otd-pg__toc-title">Auf dieser Seite</p><ol></ol>';
      pc.insertBefore(toc, pc.querySelector('.shopify-policy__body'));
    }
    var ol=toc.querySelector('ol'), used={};
    heads.forEach(function(h,i){
      if(!h.id){ var id=h.textContent.trim().toLowerCase().replace(/[äöüß]/g,function(c){return {'ä':'ae','ö':'oe','ü':'ue','ß':'ss'}[c];}).replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')||('abschnitt-'+i); while(used[id]) id+='-2'; used[id]=1; h.id=id; }
      var li=document.createElement('li'); if(h.tagName==='H3') li.className='is-sub';
      var a=document.createElement('a'); a.href='#'+h.id; a.textContent=h.textContent.trim(); li.appendChild(a); ol.appendChild(li);
    });
    toc.hidden=false; toc.closest('.otd-pg__body, .shopify-policy__container').classList.add('has-toc');
    if('IntersectionObserver' in window){
      var links=ol.querySelectorAll('a');
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ links.forEach(function(l){ l.classList.toggle('is-active', l.getAttribute('href')==='#'+e.target.id); }); } }); },{rootMargin:'0px 0px -70% 0px'});
      heads.forEach(function(h){ io.observe(h); });
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); initBuybar(); initToc(); });
  else { init(); initBuybar(); initToc(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  window.addEventListener('resize', function(){ document.querySelectorAll('[data-otd-tabs]').forEach(updateNav); });
})();
